import authConstants from '../constants';

export default function () {

    return (dispatch) => {
        dispatch({ type: authConstants.QR_CODE_DIALOG_OPEN });
    };
}